module.exports = __webpack_public_path__ + "static/media/2020-MAT Survey Results.85616298.pdf";